import type { RebillMessageResponseDto } from '@api'
import type { ColumnDef } from '@tanstack/react-table'

import InfoIcon from '@/assets/icons/icon-info.svg'
import { TooltipWithList } from '@/components/ui/table/components/tooltip-with-list.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { SequenceActionButton } from '@/modules/creator-settings/rebill-messages/components/sequence-action-button.tsx'
import {
  displayTime,
  getDateWithHoursAndMinutesFromTimeObject,
  parseTimeStringToTimObject,
} from '@/modules/creator-settings/rebill-messages/helpers/time.ts'

interface Props {
  deleteMessage: (id: number) => Promise<unknown>
  toggleMessage: (id: number, value: boolean) => Promise<unknown>
}

export function buildColumns({
  deleteMessage,
  toggleMessage,
}: Props): ColumnDef<RebillMessageResponseDto>[] {
  return [
    {
      accessorKey: 'message',
      header: 'Message',
      cell: ({ row }) => {
        return (
          <TooltipWithList
            messages={row.original.sequence?.messages || []}
            mediaOptions={[]}
          />
        )
      },
    },
    {
      id: 'timeframe',
      header: () => (
        <Tooltip
          side="right"
          sideOffset={20}
          content="Timeframe during which this message will be sent out"
        >
          <div className="flex items-center gap-1">
            Timeframe <InfoIcon className="text-secondary-300 h-4 w-4" />
          </div>
        </Tooltip>
      ),
      cell: ({ row }) => {
        const timeframeStart = row.original.timeframeStart
        const timeframeEnd = row.original.timeframeEnd
        const displayTimeframeStart = timeframeStart
          ? displayTime(
              getDateWithHoursAndMinutesFromTimeObject(
                parseTimeStringToTimObject(timeframeStart),
              ),
            )
          : 'Not Set'
        const displayTimeframeEnd = timeframeEnd
          ? displayTime(
              getDateWithHoursAndMinutesFromTimeObject(
                parseTimeStringToTimObject(timeframeEnd),
              ),
            )
          : 'Not Set'

        return (
          <div className="flex gap-4">
            {displayTimeframeStart}
            {' - '}
            {displayTimeframeEnd}
          </div>
        )
      },
    },
    {
      id: 'actions',
      header: () => <div className="flex w-full justify-end">Actions</div>,
      cell: ({ row }) => (
        <div className="flex w-full justify-end">
          <SequenceActionButton
            // @ts-ignore
            row={row}
            deleteMessage={deleteMessage}
            toggleMessage={toggleMessage}
          />
        </div>
      ),
    },
  ]
}
